import { render, staticRenderFns } from "./EditPV.vue?vue&type=template&id=d9582f12&scoped=true&lang=pug"
import script from "./EditPV.vue?vue&type=script&lang=js"
export * from "./EditPV.vue?vue&type=script&lang=js"
import style0 from "./EditPV.vue?vue&type=style&index=0&id=d9582f12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9582f12",
  null
  
)

export default component.exports